import React from "react"
import { createRoot, hydrateRoot } from "react-dom/client"
import "./index.css"
import App from "./App"
import { StyledEngineProvider } from "@mui/material"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import MUITheme from "./Configs/Themes/MUI.configs.json"

const theme = createTheme(MUITheme.AppTheme.light)
const container = document.getElementById("root") as HTMLElement

const Main = () => (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </ThemeProvider>
  </React.StrictMode>
)

const root = createRoot(container)
root.render(<Main />)
